import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Input, Popup } from 'semantic-ui-react';
import Song from './';
import { MobileModal } from '../../Modules';
import styles from '../Playlist.scss';
import '../../../lib/stylesheets/SlideUpDownTransition.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { getPosition } from '../../../lib/utils/dom';

class MobileSongSearch extends Component {
  static propTypes = {
    addToPlaylist: PropTypes.func.isRequired,
    playlist: PropTypes.object.isRequired,
    playlistContainsSong: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    clearSearch: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    query: PropTypes.string.isRequired,
    searchResults: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showMask: false,
      fixed: false,
      newPos: null
    };
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onOpen() {
    if (this.state.fixed) {
      return;
    }
    this.refs.input.inputRef.current.blur();
    this.setState(
      { fixed: true, origin: getPosition(this.refs.search).y },
      () => {
        this.setState({ showMask: true }, () => {
          this.refs.input.inputRef.current.focus();
        });
      }
    );
  }

  onClose() {
    this.setState({ showMask: false }, () => {
      this.setState({ fixed: false });
    });
  }

  render() {
    const {
      addToPlaylist,
      clearSearch,
      loading,
      onChange,
      playlist,
      playlistContainsSong,
      query,
      searchResults
    } = this.props;
    const { fixed, origin, showMask } = this.state;
    const queryPresent = query !== '';
    const fixedStyles = fixed
      ? {
        position: 'fixed',
        top: showMask ? 85 : origin,
        zIndex: 102,
        width: 'calc(100% - 2.5rem)',
        transition: 'all .3s ease-in-out'
      }
      : {};
    return (
      <div>
        <ReactCSSTransitionGroup
          transitionName='slide'
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {showMask &&
            <div
              style={{
                background: '#ffffff',
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 101,
                padding: '1.25rem',
                paddingTop: '150px'
              }}
            >
              <MobileModal.Header>
                <div className='menu'>
                  <a className='item' onClick={this.onClose}>
                    <Icon name='chevron left' />
                  </a>
                </div>
              </MobileModal.Header>
              {queryPresent &&
                searchResults.map(result => {
                  const addedLabel = (
                    <Button
                      className={styles.noBoxShadow}
                      circular
                      basic
                      size='small'
                      icon='check'
                      disabled
                    />
                  );

                  const addButton = (
                    <Popup
                      content='Add to Playlist'
                      inverted
                      position='top right'
                      trigger={
                        <Button
                          className={styles.noBoxShadow}
                          circular
                          basic
                          type='button'
                          size='small'
                          icon='add'
                        />
                      }
                    />
                  );
                  return (
                    <Song
                      key={result.id}
                      song={result}
                      actionCallback={
                        playlistContainsSong(result) ? () => {} : addToPlaylist
                      }
                      actionTrigger={
                        playlistContainsSong(result) ? addedLabel : addButton
                      }
                      parent={playlist}
                    />
                  );
                })}
            </div>}
        </ReactCSSTransitionGroup>
        <div ref='search'>
          <Input
            style={fixedStyles}
            onFocus={this.onOpen}
            loading={loading}
            size='small'
            fluid
            ref='input'
            onChange={onChange}
            value={query}
            icon={{
              name: queryPresent ? 'delete' : 'search',
              onClick: clearSearch,
              link: queryPresent
            }}
            placeholder='Search track title, artist, or album...'
          />
        </div>
      </div>
    );
  }
}

export default MobileSongSearch;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Song/MobileSearch.js